import styled from 'styled-components';
import PropTypes from 'prop-types';
import { applyStyleModifiers, styleModifierPropTypes } from 'styled-components-modifiers';

const modifierConfig = {
  center: () => `
    left: 50%;
    transform: translateX(-50%);
  `,
  right: () => `
    left: auto;
    right: 0;
  `,
  up: () => `
    bottom: 1.25rem;
  `,
};

const ListWrap = styled.div`
  display: ${(props) => (props.open ? 'block' : 'none')};
  position: absolute;
  left: 0;
  margin-top: 0.5rem;
  background-color: white;
  white-space: nowrap;
  border: 1px solid ${(props) => props.theme.palette.border};
  z-index: 2;
  border-radius: 4px;

  ${applyStyleModifiers(modifierConfig)};
`;

export default ListWrap;

ListWrap.propTypes = {
  modifiers: styleModifierPropTypes(modifierConfig),
  open: PropTypes.bool,
};

ListWrap.defaultProps = {
  open: false,
};
